module.exports = __webpack_public_path__ + "media/images/crafts/banner/traditional-aba6593ae8c31bd2781be2cd302b3d47.jpg";